import { render } from "./FaceCurrentTimeAndExpandedCenteredQR.vue?vue&type=template&id=4871c6be"
import script from "./FaceCurrentTimeAndExpandedCenteredQR.vue?vue&type=script&lang=js"
export * from "./FaceCurrentTimeAndExpandedCenteredQR.vue?vue&type=script&lang=js"

import "./FaceCurrentTimeAndExpandedCenteredQR.vue?vue&type=style&index=0&id=4871c6be&lang=scss"
script.render = render

export default script